import axios from 'axios';
axios.defaults.withCredentials = true;

export const HTTP = axios.create({
    // baseURL: 'https://kwekerijvanderlans.local/',
    baseURL: 'https://kwekerijvanderlans.nl',
    headers: {
        Authorization: 'Bearer {token}'
    }
});